import React, { useState, useEffect, useContext } from 'react'
import { Form, useNavigate } from "react-router-dom";
import { Row, Container, Col, Button } from "react-bootstrap";
import { Calendar } from './Calendar';
import { AppointmentTable } from './AppointmentTable';
import { formatDateForAPI } from '../../utils/appointmentUtils';
import axiosInstance from '../../utils/axios';
import AuthContext from '../../context/AuthContext';
import BusyLoaderOverlay from '../reusables/BusyLoaderOverlay';

const AppointmentDetails = () => {
    let { userDetails } = useContext(AuthContext)
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [pageLoading, setPageLoading] = useState(true)
    const [appointmentDetails, setAppointmentDetails] = useState([])
    const [todaysDate, setTodaysDate] = useState(new Date());
    const [currentDate, setCurrentDate] = useState(new Date());
    const [selectedButtonDate, setSelectedButtonDate] = useState(new Date());

    /* Search data based on Date */
    const onPressSearchAppointments = () => {
        let firstDate = new Date(todaysDate.getFullYear(), todaysDate.getMonth(), 1);
        let endDate = new Date(todaysDate.getFullYear(), todaysDate.getMonth() + 1, 0);

        setLoading(true);
        axiosInstance
            .get(`/appointments/`, {
                params: {
                    appointment_start_date: formatDateForAPI(firstDate),
                    appointment_end_date: formatDateForAPI(endDate),
                    clinicId: userDetails.clinic_id,
                }
            })
            .then(response => {
                if (response.status === 200) {
                    setAppointmentDetails(response.data.data)
                }
            })
            .catch(error => {
                console.error("Error fetching appointment data:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    /* Open Screen - New Appointment */
    const onPressNewAppointment = (oEvent) => {
        oEvent.preventDefault();
        navigate(`/appointment/new`, { state: { selectedButtonDate } })
    };

    useEffect(() => {
        if (pageLoading) {
            onPressSearchAppointments()
        }
        setPageLoading(false);

    }, [pageLoading, todaysDate]);

    return (
        <>
            <Container fluid className="p-4 bg-light min-vh-100">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h3>Doctor's Appointment Calendar</h3>
                    {userDetails.is_clinic_plan_expired === false ? (
                        <>
                            <div>
                                <Button type='submit' variant='primary' className="d-none d-md-block" disabled={userDetails.user_type === "M"} style={{ float: "right" }} onClick={onPressSearchAppointments} >Refresh Appointments</Button>
                                <Button type='submit' variant='primary' className='mr-2' style={{ float: "right" }} onClick={onPressNewAppointment} >Book Appointment</Button>
                            </div>
                        </>
                    ) : null}
                </div>

                <Row>
                    <Col lg={4} className='mb-3'>
                        <Calendar
                            appointments={appointmentDetails}
                            setAppointments={setAppointmentDetails}
                            onDateSelect={setTodaysDate}
                            selectedDate={todaysDate}
                            currentDate={currentDate}
                            setSelectedButtonDate={setSelectedButtonDate}
                            onMonthChange={setCurrentDate}
                        />
                    </Col>
                    <Col lg={8}>
                        <AppointmentTable
                            appointments={appointmentDetails}
                            selectedDate={todaysDate}
                            userDetails={userDetails}
                            onPressSearchAppointments={onPressSearchAppointments}
                        />
                    </Col>
                </Row>
            </Container>
            <BusyLoaderOverlay show={loading} />
        </>
    )
}

export default AppointmentDetails